<fgb-account-layout titleKey="fgbcl.refer.a.friend" titleDefault="Refer a Friend">
  <fgb-account-panel titleKey="fgbcl.refer.a.friend" titleDefault="Refer a Friend">
    <div class="refer-content">
      <p class="refer-description">
        {{
          'fgbcl.refer.friend.description'
            | translate
              : {
                  fgbdefault:
                    'Invite friends and earn rewards! Share your referral link, and both you and your friends get exclusive perks when they sign up. You can copy and share the invitation link or referral code.'
                }
        }}
      </p>

      <div class="copy-field-box">
        <span class="copy-field-text">{{
          linktoggle ? ('fgbcl.refer.friend.link.copied' | translate : { fgbdefault: 'Link Copied' }) : url
        }}</span>
        <button
          type="button"
          class="copy-field-icon-btn"
          (click)="copyCodeToClipboardLowercase(url)"
          aria-label="Copy link"
        >
          <img src="assets/images/icons/secondary-icon-copy.svg" alt="" width="24" height="24" />
        </button>
      </div>

      <div class="copy-field-box">
        <span class="copy-field-text">
          <ng-container *ngIf="!toggle">{{ 'fgbcl.refer.friend.code.label' | translate : { fgbdefault: 'Referral Code:' } }} </ng-container>
          <strong>{{ toggle ? ('fgbcl.refer.friend.code.copied' | translate : { fgbdefault: 'Code Copied' }) : code }}</strong>
        </span>
        <button
          type="button"
          class="copy-field-icon-btn"
          (click)="copyCodeToClipboardUppercase(code)"
          aria-label="Copy code"
        >
          <img src="assets/images/icons/secondary-icon-copy.svg" alt="" width="24" height="24" />
        </button>
      </div>

      <div class="refer-divider">
        <span class="refer-divider-line"></span>
        <span class="refer-divider-text">{{ 'fgbcl.refer.friend.or' | translate : { fgbdefault: 'Or' } }}</span>
        <span class="refer-divider-line"></span>
      </div>

      <form [formGroup]="referAFriendForm" class="refer-form">
        <div class="detail-field-box">
          <div class="detail-field-text">
            <label class="detail-field-label" for="floatingFullnameValue">{{
              'fgbcl.refer.fullname' | translate : { fgbdefault: 'Full Name' }
            }}</label>
            <input id="floatingFullnameValue" type="text" class="detail-field-input" formControlName="fullname" />
          </div>
        </div>
        <div class="detail-field-box">
          <div class="detail-field-text">
            <label class="detail-field-label" for="floatingEmailValue">{{
              'fgbcl.refer.email.address' | translate : { fgbdefault: 'Email Address' }
            }}</label>
            <input id="floatingEmailValue" type="email" class="detail-field-input" formControlName="email" />
          </div>
        </div>
      </form>

      <div class="refer-actions">
        <button
          type="button"
          class="btn-filled-success"
          [disabled]="successFlag || !referAFriendForm?.valid"
          (click)="sendReferral(referAFriendForm.value)"
        >
          {{ 'fgbcl.refer.friend.submit' | translate : { fgbdefault: 'Send' } }}
        </button>
      </div>
      <div class="refer-success-text" *ngIf="successFlag">
        {{ 'refer.submit.success' | translate : { fgbdefault: 'Referral sent successfully!' } }}
      </div>
    </div>
  </fgb-account-panel>
</fgb-account-layout>
